<div class="relative w-full bg-white p-12 shadow-lg mt-[80px]">
    <div class="w-full md:w-[85%] mx-auto flex items-center justify-start">
        <h1 class="text-3xl font-bold text-gray-900 aarni-font">
            {{ pageTitle }}
        </h1>
    </div>
</div>

<section class="aarni-font">
    <div class="container mx-auto flex flex-col lg:flex-row gap-8 py-12 px-4">
        <aside class="w-full lg:w-1/4 space-y-4 h-fit overflow-y-auto">
            <div class="border-t-8 border-blue-400">
                <div class="bg-white shadow border border-gray-300">
                    <h2 class="text-lg font-bold p-4">What's Happening</h2>
                    <div class="">
                        <a [href]="'/whats-happening/event-calendar'"
                           class="flex items-center space-x-2 p-3 w-full border-y text-blue-600 border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Event Calendar</span>
                        </a>
                     <!--   <a [href]="'/quick-links/upcoming-events'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Upcoming Events', 'text-blue-600 bg-white' : pageTitle !== 'Upcoming Events'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Upcoming Events</span>
                        </a>-->
                        <a [href]="'/quick-links/announcements'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Announcements', 'text-blue-600 bg-white' : pageTitle !== 'Announcements'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Announcements</span>
                        </a>
                        <a [href]="'/quick-links/news'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'News', 'text-blue-600 bg-white' : pageTitle !== 'News'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>News</span>
                        </a>
                    </div>
                </div>
            </div>
            <h2 class="text-lg font-semibold mb-4">Quick Links</h2>
            <div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/quick-links/student-testimonial" class="flex items-center space-x-3 p-2 rounded-lg">
                        <div>
                        <span class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full">
                            <i class="fa fa-comment text-2xl"></i>
                        </span>
                        </div>
                        <span class="text-gray-700 font-medium md:text-[16px] xl:text-xl">Testimonials</span>
                    </a>
                </div>
            </div>
            <div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/whats-happening/event-calendar" class="flex items-center space-x-3 p-2 rounded-lg">
                        <div>
                        <span class="w-16 h-16 flex items-center justify-center bg-yellow-500 text-white rounded-full">
                          <i class="fa fa-calendar text-2xl"></i>
                        </span>
                        </div>
                        <span class="text-gray-700 font-medium  md:text-[16px] xl:text-xl">What's Happening</span>
                    </a>
                </div>
            </div>
            <div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/quick-links/contact-us" class="flex items-center space-x-3 p-2 rounded-lg ">
                        <div>
            <span class="w-16 h-16 flex items-center justify-center bg-pink-600 text-white rounded-full">
                <i class="fa fa-phone text-2xl"></i>
            </span>
                        </div>
                        <span class="text-gray-700 font-medium md:text-[16px] xl:text-xl">Contact Us</span>
                    </a>
                </div>
            </div>
            <div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/quick-links/image-gallery" class="flex items-center space-x-3 p-2 rounded-lg ">
                        <div>
            <span class="w-16 h-16 flex items-center justify-center bg-blue-600 text-white rounded-full">
                <i class="fa fa-camera text-2xl"></i>
            </span>
                        </div>
                        <span class="text-gray-700 font-medium md:text-[16px] xl:text-xl">Image Gallery</span>
                    </a>
                </div>
            </div>
        </aside>
        <div class="flex-1">
            <div
                class="shadow-lg border-gray-200 bg-white h-fit border"
                [ngClass]="{ 'p-4': pageTitle === 'Announcements', 'p-12': pageTitle !== 'Announcements' }"
            >
                <h3 class="font-semibold text-[22px]">
                    {{ pageTitle }}
                </h3>

              <!--  <div *ngIf="pageTitle === 'Upcoming Events'">
                </div>-->

                <div *ngIf="pageTitle === 'Announcements'" class="p-4 space-y-4 max-w-5xl mx-auto border w-full">
                    <div *ngFor="let item of announcements; let i = index" class="border rounded-lg overflow-hidden w-full">
                        <div class="flex items-center justify-between p-4 cursor-pointer w-full" (click)="toggleAccordion(i)">
                            <div
                                class="w-12 h-12 mr-4 flex-col justify-center items-center text-white rounded hidden md:flex"
                                [ngStyle]="{ 'background-color': item.color }"
                            >
                                <span class="text-sm font-bold">{{ formatDay(item.date) }}</span>
                                <span class="text-xs">{{ formatMonth(item.date) }}</span>
                            </div>
                            <div class="flex-1 font-medium text-xs md:text-xl" [ngClass]="openedIndex === i ? 'text-pink-600' : 'text-gray-800'">
                                {{ item.title }}
                            </div>

                            <div class="text-md md:text-xl" [ngClass]="openedIndex === i ? 'text-pink-600' : 'text-gray-700'">
                                <i class="fa" [ngClass]="openedIndex === i ? 'fa-minus' : 'fa-plus'"></i>
                            </div>
                        </div>

                        <div *ngIf="openedIndex === i" class="p-4 bg-white text-gray-700">
                            <p class="text-xs md:text-lg">{{ item.description }}</p>
                            <a
                                *ngIf="item.downloadUrl && !item.openExternally"
                                href="#"
                                (click)="openPdfModal($event, item.downloadUrl)"
                                class="text-blue-600 underline mt-2 hidden lg:inline"
                            >
                                {{ item.downloadLabel }}
                            </a>

                            <a
                                *ngIf="item.downloadUrl && item.openExternally"
                                [href]="item.downloadUrl"
                                target="_blank"
                                rel="noopener"
                                class="text-blue-600 underline mt-2 hidden lg:inline"
                            >
                                {{ item.downloadLabel }}
                            </a>

                            <a
                                *ngIf="item.downloadUrl"
                                [href]="item.downloadUrl"
                                target="_blank"
                                rel="noopener"
                                class="text-blue-600 underline mt-2 inline-block lg:hidden text-xs md:text-lg"
                            >
                                {{ item.downloadLabel }}
                            </a>
                        </div>
                    </div>
                    <div *ngIf="pdfUrl" class="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 px-4">
                        <div class="relative w-full max-w-5xl mx-auto">
                            <div class="flex justify-end mb-2">
                                <button
                                    (click)="closePdfModal()"
                                    class="text-white text-2xl font-bold border border-white rounded-md w-10 h-10 flex items-center justify-center hover:bg-white hover:text-black transition"
                                >
                                    &times;
                                </button>
                            </div>

                            <div class="relative w-full pt-[56.25%] rounded-lg shadow-lg overflow-hidden">
                                <iframe
                                    [src]="sanitizedPdfUrl"
                                    class="absolute top-0 left-0 w-full h-full"
                                    frameborder="0"
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    *ngIf="selectedEvent"
                    class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4"
                >
                    <div class="bg-white max-w-6xl h-[550px] md:h-[800px] w-full p-6 rounded-lg shadow-xl relative">
                        <button
                            (click)="closeModal()"
                            class="absolute top-2 right-2 text-gray-600 hover:text-red-500 text-5xl font-bold"
                        >
                            &times;
                        </button>
                        <div class="h-2/3 px-4">
                            <img [src]="selectedEvent.image" [alt]="selectedEvent.title" class="w-full h-full"/>
                        </div>
                        <div class="h-1/3 overflow-y-auto thin-scrollbar p-4">
                            <h2 class="text-xl font-bold mt-4">{{ selectedEvent.title }}</h2>
                            <p class="mt-2 text-sm text-gray-600">{{ selectedEvent.date }}</p>
                            <p class="mt-4 text-gray-700 text-justify">
                                {{ selectedEvent.description || 'Detailed news content goes here...' }}
                            </p>
                        </div>
                    </div>
                </div>

                <div *ngIf="pageTitle === 'News'" class="p-4">
                    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                        <div
                            *ngFor="let image of mediaImages"
                            class="relative cursor-pointer group"
                            (click)="openOverlay(image)"
                        >
                            <a [href]="image.url" target="_blank">
                                <img
                                    [src]="image.src"
                                    alt="Media"
                                    class="w-full h-60 object-cover shadow rounded-md"
                                />
                            </a>

                            <!-- Date badge -->
                            <div
                                class="absolute top-2 left-2 bg-pink-500 text-white text-xs px-2 py-1 rounded z-10"
                            >
                                {{ image.date | date: 'dd MMM yyyy' }}
                            </div>

                            <!-- Text overlay -->
                            <div
                                class="absolute bottom-0 left-0 w-full bg-black bg-opacity-70 text-white text-sm px-4 py-2 rounded-t-md transition-all duration-300 group-hover:bg-opacity-70 z-0"
                            >
                                {{ image.text }}
                            </div>
                        </div>
                    </div>


                    <!-- <div
                         *ngIf="selectedImage"
                         class="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
                         (click)="closeOverlay()"
                     >
                         <div class="relative max-w-3xl w-full px-4" (click)="$event.stopPropagation()">
                             <button
                                 class="absolute top-2 right-2 text-white text-3xl"
                                 (click)="closeOverlay()"
                                 aria-label="Close"
                             >
                                 &times;
                             </button>
                             <img
                                 [src]="selectedImage.src"
                                 alt="Full View"
                                 class="w-full max-h-[80vh] object-contain rounded"
                             />
                         </div>
                     </div>-->
                </div>
            </div>
        </div>
    </div>
</section>

